module.exports = __webpack_public_path__ + "static/media/saturn-2.e4fd8290.jpg";